import { type Control } from 'react-hook-form';
import { ControlledCheckbox, ErrorMessage } from '@/src/ui';
import type { QtiGraphingQuestionDTO } from '@/src/lib';

export interface GraphingAdditionalMetaEditorProps {
    control: Control<QtiGraphingQuestionDTO>;
    disableList?: Array<'allowPoints' | 'allowSegments' | 'allowRays' | 'allowLines'>;
    allDisabled: boolean;
}

export default function GraphingAdditionalMetaEditor({
    control,
    disableList,
    allDisabled,
}: GraphingAdditionalMetaEditorProps) {
    return (
        <div>
            <h2>Allowed object types:</h2>
            <div className="grid grid-cols-4 gap-3">
                <ControlledCheckbox
                    name="additionalMeta.allowPoints"
                    label={'Allow Points'}
                    disabled={disableList?.includes('allowPoints') || allDisabled}
                    onChange={(e, field) => {
                        const checked = e.target.checked;
                        field.onChange(checked);
                    }}
                    control={control}
                />

                <ControlledCheckbox
                    name="additionalMeta.allowSegments"
                    label={'Allow Segments'}
                    disabled={disableList?.includes('allowSegments') || allDisabled}
                    onChange={(e, field) => {
                        const checked = e.target.checked;
                        field.onChange(checked);
                    }}
                    control={control}
                />

                <ControlledCheckbox
                    name="additionalMeta.allowRays"
                    label={'Allow Rays'}
                    disabled={disableList?.includes('allowRays') || allDisabled}
                    onChange={(e, field) => {
                        const checked = e.target.checked;
                        field.onChange(checked);
                    }}
                    control={control}
                />

                <ControlledCheckbox
                    name="additionalMeta.allowLines"
                    label={'Allow Lines'}
                    disabled={disableList?.includes('allowLines') || allDisabled}
                    onChange={(e, field) => {
                        const checked = e.target.checked;
                        field.onChange(checked);
                    }}
                    control={control}
                />
            </div>

            <ErrorMessage
                error={
                    allDisabled
                        ? 'Please remove all points and lines to change allowed object types.'
                        : ''
                }
                color="yellow"
            />
        </div>
    );
}
